module.exports = "<div class='bg-white'>\r\n    {{version}} v\r\n</div>\r\n"